import { FragmentMediaPlayerSkeleton } from '../FragmentMediaPlayerSkeleton';

interface AudioSkeletonProps {
  showLoader?: boolean;
  /** Export progress percent while the audio asset is being generated. */
  progressPercent?: number;
}

/**
 * Audio-shaped skeleton matching the fragment single VideoJS audio player layout.
 * Spinner and message are centered over the player placeholder.
 */
export function AudioSkeleton(props: AudioSkeletonProps) {
  return <FragmentMediaPlayerSkeleton aspectRatio="16 / 3" {...props} />;
}
